import { useNavigate, useRoutes, useLocation, type NavigateFunction } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = (nav) => resolve(nav);
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [displayLocation, setDisplayLocation] = useState(location);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate;
      if (navigateResolver) navigateResolver(navigate);
    }
  }, [navigate]);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      // 遷移開始
      setIsTransitioning(true);

      const timer = setTimeout(() => {
        // アニメーション完了後に状態を同期
        setDisplayLocation(location);
        setIsTransitioning(false);
        prevPath.current = location.pathname;
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, location]);

  const isPC = typeof window !== 'undefined' && window.innerWidth >= 1024;

  return (
    <div style={{ position: 'relative', width: '100%', minHeight: '100vh' }}>
      
      {/* 【下のレイヤー】新しいページ：常に100%の幅で背後に存在 */}
      <div style={{ width: '100%', minHeight: '100vh' }}>
        {element}
      </div>

      {/* 【上のレイヤー】古いページ：遷移中だけ絶対配置で重なり、右へスライド */}
      {isTransitioning && isPC && (
        <div className="top-layer-slide-out">
          {/* 内部で幅が崩れないよう、100%のコンテナで包む */}
          <div style={{ width: '100%' }}>
            {useRoutes(routes, displayLocation)}
          </div>
        </div>
      )}
    </div>
  );
}